module.exports = __webpack_public_path__ + "img/image10@3x.d7534d83.png";